import type { AgenteClaveDTO } from '../../../model/kartera-api-model'

export { errorMessage, formatCount, RamoMark } from '../../customers/common/customer-common'

export const AGENT_KEYS_PATH = '/claves'
export const AGENT_KEYS_BACK_PATH = '/configuracion'
export const NEW_AGENT_KEY_PATH = `${AGENT_KEYS_PATH}/nueva`

export const agentKeyPath = (id: number) => `${AGENT_KEYS_PATH}/${id}`

export type RamoKey = 'vida' | 'autos' | 'salud' | 'diversos'
export type ComisionKey = 'comisionVida' | 'comisionAutos' | 'comisionSalud' | 'comisionDiversos'

export interface RamoConfig {
    id: RamoKey
    label: string
    short: string
    ramo: string
    comision: ComisionKey
}

export const RAMOS: RamoConfig[] = [
    { id: 'vida', label: 'Vida', short: 'V', ramo: 'vida', comision: 'comisionVida' },
    { id: 'autos', label: 'Autos', short: 'A', ramo: 'autos', comision: 'comisionAutos' },
    { id: 'salud', label: 'Salud', short: 'S', ramo: 'salud', comision: 'comisionSalud' },
    { id: 'diversos', label: 'Daños', short: 'D', ramo: 'daños', comision: 'comisionDiversos' },
]

export const activeRamos = (clave: Pick<AgenteClaveDTO, RamoKey>) => RAMOS.filter((ramo) => clave[ramo.id])

export interface FormMessage {
    type: 'error' | 'success'
    message: string
}

/** `state` de navegación para mostrar un aviso al volver a la lista. */
export interface AgentKeysLocationState {
    backUrl?: string
    flash?: string
}
